import apiProxy from "@shared/utils/api-proxy.ts";
import { ConsumptionStorageType } from "@shared/types/localTypes/usage-explorer.ts";
import { FetchUsageResponse } from "@shared/services/usage-explorer/fetchUsage.ts";

export interface FetchConsumptionRequest {
  subscription: number;
  storage_type: ConsumptionStorageType;
  partition_by: "month";
  start_date: string;
  end_date: string;
  period_group_limit: number;
  partition_group_limit: number;
  nonce: string;
}

export default async ({ request }: { request: FetchConsumptionRequest }) => {
  const response: FetchUsageResponse | null = await apiProxy.post(
    "usage-explorer/consumption/get-dashboard-data",
    request,
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
